<script lang="ts">
  import { Link } from 'svelte-routing';

  // Shared brand mark — globe glyph + "AtlasGuess" wordmark (with the
  // emphasised "Guess"). Used by both Sidebar (game shell) and TopNav
  // (auth/account/static shell) so the brand reads identically across
  // every entry point. Wraps in a <Link to="/"> so the logo always
  // returns the player home.
  //
  // Sizing is driven by the wrapper's own CSS — the SVG inherits its
  // pixel size from `.brand-mark__icon` so the parent shell can pick a
  // 24px (sidebar) or 26px (top-nav, currently same) box without forking
  // this component.
</script>

<Link
  to="/"
  getProps={() => ({
    class: 'brand-mark',
    'aria-label': 'AtlasGuess home',
  })}
>
  <span class="brand-mark__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="12" cy="12" r="9" />
      <ellipse cx="12" cy="12" rx="9" ry="3.5" />
      <line x1="12" y1="3" x2="12" y2="21" />
      <ellipse cx="12" cy="12" rx="3.5" ry="9" />
    </svg>
  </span>
  <span class="brand-mark__text">
    Atlas<strong>Guess</strong>
  </span>
</Link>
